import React, { useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../reducer/alertSlice";
import styled from "styled-components";

const Options = styled.ul`
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 0;
    transform: translateY(46px);
    width: 100%;
    background-color: #fff;
    z-index: 10;
    border: 0.0625rem solid rgba(231, 234, 243, 0.7);
    border-radius: 0.3125rem;
    max-height: 300px;
    overflow: auto;
    li {
        border: none;
        &:hover {
            border: none;
            background-color: rgba(231, 234, 243, 0.3);
        }
    }
`

const InputGroupValidation = ({type="text", register, invalid, data=[], numAndScOnly = false, max = 4, setValue, ...props}) => {
    const dispatch = useDispatch();

    //select option 관련 state
    const [showOptions, setShowOptions] = useState(false);
    const [selectValue, setSelectValue] = useState(props.defaultValue ? props.defaultValue : "");
    const [selectLabel, setSelectLabel] = useState(props.defaultValue ? props.defaultValue : "");

    const [fileName, setFileName] = useState(props.defaultValue ? props.defaultValue : "");
    const [filePath, setFilePath] = useState(props.path ? props.path : "");

    useEffect(() => {
        const handleClickDocument = (e) => {
            e.stopPropagation();
            if (selectBoxRef.current) {
                if (!selectBoxRef.current.contains(e.target)) {
                    setShowOptions(false);
                }
            }
        }

        document.addEventListener("click", handleClickDocument);

        return () => {
            document.removeEventListener("click",handleClickDocument);
        }
    },[]);

    useEffect(() => {
        if (setValue) {
            setValue(register.name, selectValue);
            if (selectRef.current) {
                selectRef.current.dispatchEvent(new Event("input", { bubbles: true }));
            }
        }
    },[selectValue]);

    const selectBoxRef = useRef();
    const selectRef = useRef();

    // Radio, checkbox
    if (type === "radio" || type === "checkbox") {
        return (
            <InputGroup hasValidation className="gap-2">
                {
                    data.map((v, i) => {
                        return (
                            <Form.Check className="me-0" key={i} inline id={register.name + i}>
                                <Form.Check.Input {...register} 
                                    checked={props.checkedValue == v.value}
                                    onChange={(e) => {
                                        if (props.onChange) {
                                            props.onChange(e);
                                            register.onChange(e);
                                        }
                                    }}
                                    type={type} value={v.value} isInvalid={invalid} 
                                    />
                                <Form.Check.Label>{v.label}</Form.Check.Label>
                            </Form.Check>
                        )
                    })
                }
            </InputGroup>
        )
    }

    // select option
    if (type === "select") {
        return (
            <>
            <Form.Control 
                type="hidden"
                {...register}
                value={selectValue}
                ref={e => {
                    if (register) {
                        register.ref(e);
                        selectRef.current = e;
                    }
                }}
                onInput={(e) => {
                    // react-hook-form update
                    register.onChange(e);
                }}
            />
            <InputGroup hasValidation ref={selectBoxRef}>
                <Form.Control 
                    className="form-select"
                    isInvalid={invalid}
                    onClick={() => {
                        setShowOptions(true);
                    }} 
                    placeholder={props.placeholder}
                    value={selectLabel}
                    readOnly 
                />
                {
                showOptions &&
                <Options className="custom-scroll">
                    {
                        data.map((el) => {
                            return (
                            <li key={el.value} 
                                className="form-control"
                                onClick={(e) => {
                                    setSelectValue(el.value);
                                    setSelectLabel(el.label);
                                    setShowOptions(false);
                                }}
                            >{el.label}</li>
                        )
                        })
                    }
                </Options>
                }
                <Form.Control.Feedback type="invalid">{invalid && invalid["message"]}</Form.Control.Feedback>
            </InputGroup>
            </>
        );
    }

    // file
    if (type === "file") {
        const handleChangeFile = (e) => {
            const maxSize = max * 1024 * 1024;
            if (e.target.files[0]) {
                if (e.target.files[0].size > maxSize) {
                    dispatch(showAlert({
                        msg: "최대 "+max+"MB 파일까지 등록가능합니다."
                    }));
                    e.target.value = "";
                    return;
                }
            }
            register.onChange(e);
            register.onBlur(e);
        }
        if (props.defaultValue) {
            return (
            <InputGroup hasValidation>
                <Form.Control className="crsor-pointer" type="text" isInvalid={invalid} placeholder="등록된 파일 없음" value={fileName} readOnly onClick={() => {
                    const image = new Image();
                    image.src = filePath;
                    const w = window.open("");
                    w.document.write(image.outerHTML);
                }}></Form.Control>
                
                <label className="btn btn-primary">
                    <Form.Control {...register} 
                            style={{display: "none"}}
                            type="file" 
                            isInvalid={invalid} 
                            onChange={(e) => {
                                setFileName(e.target.files[0] ? e.target.files[0].name : "")
                                handleChangeFile(e);
                                var reader = new FileReader();
                                reader.readAsDataURL(e.target.files[0]);
                                reader.onload = function(event) {
                                    setFilePath(event.target.result);
                                };
                            }}
                            {...props}
                            defaultValue=""
                    >
                    </Form.Control>
                    업로드
                </label>
                <Form.Control.Feedback type="invalid">{invalid && invalid['message']}</Form.Control.Feedback>
            </InputGroup>
            )
        }
        return (
            <InputGroup hasValidation>
                <Form.Control {...register} type="file" isInvalid={invalid} 
                onChange={(e) => {
                    handleChangeFile(e)
                }} {...props}></Form.Control>
                <Form.Control.Feedback type="invalid">{invalid && invalid['message']}</Form.Control.Feedback>
            </InputGroup>
        )
    }

    // text, textarea
    return (
        <InputGroup hasValidation>
            {
                type === "textarea"
                ?
                <Form.Control as="textarea" {...register} isInvalid={invalid} {...props} />
                :
                <Form.Control type={type} {...register} isInvalid={invalid} {...props}
                    onInput={(e)=>{
                        if (props.onInput) {
                            props.onInput(e);
                        }
                    
                        if (numAndScOnly){
                            e.target.value = e.target.value.replace(/[^\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"0-9]/g, "");
                        }

                        if (props.withoutSc){
                            e.target.value = e.target.value.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g, "");
                        }
                    }} 
                />
            }
            <Form.Control.Feedback type="invalid">{invalid && invalid['message']}</Form.Control.Feedback>
        </InputGroup>
    )
};

export default InputGroupValidation;